export default __webpack_public_path__ + "static/media/peercoin-main.6b9e8f66.png";